(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { HtmlElement } from "../base";
import { SPACE } from "../../constants/style.js";
var StyledHeading = styled(HtmlElement).withConfig({
  displayName: "Heading__StyledHeading",
  componentId: "sc-3jfc5-0"
})(["color:", ";", " ", " ", " ", " ", " ", " ", " ", " ", " &:first-child{margin-top:0;}"], function (props) {
  return props.theme.styles.colors.headings;
}, function (props) {
  return (// Reverse values of the SPACE constants and use the biggest for level 1
    // and so on. Let's see how that works.
    props.level && "margin-top: ".concat(_toConsumableArray(Object.values(SPACE)).reverse()[props.level], ";")
  );
}, function (props) {
  return props.level === 2 && "\n    text-align: center;\n    margin-bottom: ".concat(SPACE.xxl, ";\n    font-size: 32px;\n    font-weight: 500;\n    letter-spacing: -0.025em;\n  ");
}, function (props) {
  return props.level === 3 && "\n    font-size: 24px;\n    margin-bottom: ".concat(SPACE.lg, ";\n    font-weight: 500;\n    letter-spacing: -0.025em;\n  ");
}, function (props) {
  return props.level === 4 && "\n    font-size: 18px;\n    text-transform: uppercase;\n    font-weight: 500;\n    margin-bottom: ".concat(SPACE.md, ";\n    padding-bottom: ").concat(SPACE.xs, ";\n    width: auto;\n    display: inline-block;\n  ");
}, function (props) {
  return props.level === 5 && "\n    font-size: 16px;\n    text-transform: uppercase;\n    font-weight: 500;\n    letter-spacing: -0.025em;\n    border-bottom: 2px solid #f6f6f6;\n    margin-bottom: ".concat(SPACE.md, ";\n    padding-bottom: ").concat(SPACE.xs, ";\n    width: auto;\n    display: inline-block;\n  ");
}, function (props) {
  return props.level === 6 && "\n    font-size: 14px;\n    text-transform: uppercase;\n    font-weight: 800;\n    letter-spacing: -0.025em;\n    margin-bottom: ".concat(SPACE.sm, ";\n    width: auto;\n    display: inline-block;\n  ");
}, function (props) {
  return props.center && "text-align: center;";
}, function (props) {
  return props.fontSize && "font-size: ".concat(props.fontSize, ";");
}, function (props) {
  return props.marginBottom && "margin-bottom: ".concat(props.marginBottom, ";");
});

var Heading = function Heading(props) {
  var children = props.children,
      tagName = props.tagName,
      level = props.level;
  return React.createElement(StyledHeading, _extends({}, props, {
    tagName: "".concat(tagName || "h".concat(level))
  }), children);
};

Heading.propTypes = {
  level: PropTypes.number
};
Heading.defaultProps = {
  level: 3
};
var _default = Heading;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledHeading, "StyledHeading", "/home/vsts/work/1/s/src/components/text/Heading.js");
  reactHotLoader.register(Heading, "Heading", "/home/vsts/work/1/s/src/components/text/Heading.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/text/Heading.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();